(function () {
  // Modifie ici le seuil mini : 12 = pas de césure pour <= 11 caractères
  var MIN_LEN = 12;

  function longestWordLen(text) {
    if (!text) return 0;
    // découpe sur espaces/tab, garde lettres/chiffres/accents/tiret
    const words = text.trim().split(/\s+/);
    let max = 0;
    for (let i = 0; i < words.length; i++) {
      const w = words[i].replace(/[^\p{L}\p{N}-]/gu, ""); // Unicode safe
      // Si tu veux que "hard-rock" compte comme deux mots, dé-commente :
      // const parts = w.split('-');
      // for (const p of parts) if (p.length > max) max = p.length;
      if (w.length > max) max = w.length;
    }
    return max;
  }

  function applyHyphenation(root) {
    const nodes = root.querySelectorAll(
      '.artist-logos-grid .artist-text, .artist-logos-grid .menu-item__text'
    );
    nodes.forEach((el) => {
      const len = longestWordLen(el.textContent || "");
      if (len >= MIN_LEN) {
        el.classList.add("hyphenate");
      } else {
        el.classList.remove("hyphenate");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    applyHyphenation(document);

    // Ré-appliquer à l’ouverture des mega-menus
    document.querySelectorAll("details.mega-menu").forEach((d) => {
      d.addEventListener("toggle", () => applyHyphenation(d));
    });

    // Filet de sécurité si le DOM change
    const obs = new MutationObserver(() => applyHyphenation(document));
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
